<template>
  <div>
    <h1 class="mb-5">{{ msg }}</h1>

    <b-form-input
      v-model="filter"
      class="mb-3"
      placeholder="Filter SFTP resources"
    />

    <TableList
      :data="filteredBoxes"
      :fields="fields"
      :loading="loading"
      selectable_field="id"
      @rowClick="$emit('rowClick', $event)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TableList from './common/ResourceList.vue'

export default {
  name: 'ResourceList',
  components: {
    TableList
  },
  data() {
    return {
      filter: '',
      fields: [
        { key: 'id', label: 'Box ID', sortable: true },
        { key: 'url', label: 'URL', sortable: true }
      ],
      msg: 'SFTP Boxes'
    }
  },
  async created() {
    await this.load()
  },
  computed: {
    ...mapState({
      boxes: state => state.otherResources.resource_list,
      loading: state => state.otherResources.loading
    }),
    filteredBoxes() {
      const filter = this.filter.toLowerCase().trim()

      if (!filter) return this.boxes

      return this.boxes.filter(box =>
        Object.values(box).some(value =>
          String(value ?? '').toLowerCase().includes(filter)
        )
      )
    }
  },
  methods: {
    async load() {
      await this.$store.dispatch('otherResources/listBoxes')
    }
  }
}
</script>